import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MessageService } from 'primeng/api';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-vendor',
  standalone: false,
  templateUrl: './vendor.component.html',
  styleUrl: './vendor.component.scss'
})
export class VendorComponent implements OnInit, OnDestroy {
  @Output() stepCompleted = new EventEmitter<void>();
  visible: boolean = false;
  commentForm: FormGroup;
  selectedVendor: any;
  @Input() id: any
  @Input() step: any;
  @Input() schemeType: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  selectedVendorList: any[] = [

  ];
  venderList: any[] = []
  filteredVendors: any[];
  payload: {
    proposal_id: any;
    proposal_name: any;
    scheme:any;
  };
  selectedMasterVendor: any[] = []
  masterVendorList: any[] = []
  selectedvendor: any
  title:string
  private subscriptions = new Subscription();
  cols: any[] = [
    { field: 'name', header: 'Name', filterType: 'text' },
    { field: 'contact', header: 'Contact Person', filterType: 'text' },
    { field: 'phone_number', header: 'Contact Number', filterType: 'text' },
    { field: 'email', header: 'Email', filterType: 'text' },
    // { field: 'documentName', header: 'Document', filterType: 'link' },

  ];
  incubator_cols: any[] = [
    { field: 'vendor.name', header: ' Name', filterType: 'text', width: '200px' },
    { field: 'vendor.description', header: 'Description', filterType: 'text', width: '300px' },

  ];
  systemForm: FormGroup;
  incubatorList:any;
  userID: any;
  resId:any;
  constructor(private fb: FormBuilder, private config: PrimeNGConfig, private messageService: MessageService, private api: ApiService, private route: ActivatedRoute) {
    this.commentForm = this.fb.group({
      vendor: ['', Validators.required],
      contactPerson: ['', [Validators.required, Validators.pattern(/^[A-Za-z\s]+$/)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required]],
      address: ['', [Validators.required , Validators.pattern('^[a-zA-Z0-9 ,.()&-]+$')]],
      taxNumber: ['', [Validators.required,Validators.pattern('^[a-zA-Z0-9 ,.()&-]+$')]],
      bankDetails: ['', Validators.required],
      // upload: ['', Validators.required]
    });
    this.systemForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      selectedOptions: [[]]
    });
      const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      const scheme = params['scheme'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
        scheme:scheme
      }
    });
    this.getVendorIdentification();
    if(this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII' ){
      this.title = 'List of Development Agencies'
    }else{
   this.title = 'List of Vendors'
    }
    this.getVendorList();

  }

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
  {
    basicInfo: false,
    equipment: false,
    quantity: false,
    cost: false,
    detailedInfo: false,
    uploads: false,
    fileTable: true,
    vendorTable: false
  };

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  getVendorList() {
     this.api.getAPI(`/master/vendor/`).subscribe((res: any) => {
      this.masterVendorList = res.data;
      
    });

    
  }

  filterVendor(event: any) {
    let query = event.query.toLowerCase();

    this.filteredVendors = this.venderList.filter(vendor =>
      vendor.name.toLowerCase().includes(query)
    );
  }

  removeVendor(vendor: any) {
    let url;
    if (this.schemeType == 'idex') {
      url = `/idex/vendor-identification/${vendor.id}/`
    } else if(this.schemeType == 'tdf'){
      url = `/tdf/vendor-identification/${vendor.id}/`
    } else {
      url = `/revenue/vendor-identification/${vendor.id}/`
    }
    const sub = this.api.deleteAPI(url).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Vendor deleted successfully'
      });
      this.selectedVendorList = this.selectedVendorList.filter(v => v !== vendor);
    });
    this.subscriptions.add(sub);
  }
  totalRecords: number = 0;
  getVendorIdentification(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();
    let url;
     if (this.schemeType == 'idex') {
      url = `/idex/vendor-identification/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}&page=${page}`
    } else if(this.schemeType == 'tdf'){
      url = `/tdf/vendor-identification/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}&page=${page}`
    } else if(this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII'){
      url = `/make1/vendor-identification/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}&page=${page}`
    } 
    else {
      url = `/revenue/vendor-identification/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}&page=${page}`
    }
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res: any) => {
      if(this.schemeType == 'idex'){
        this.incubatorList = res.results
      }else if(this.schemeType == 'tdf'){
        this.venderList = res.tdfvendor_step || [];
        this.resId = res.id
      }else if(this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII'){
        this.venderList = res.vendormake_step || [];
        this.resId = res.id
      }
      else{
        // this.venderList = res.results;
        this.resId = res.id
        // if(this.schemeType == 'rev'){
          this.venderList = res.revenuevendor_step
        // }
      }
      this.totalRecords = res.count || res.tdfvendor_step?.length || res.revenuevendor_step?.length || 0
    });
  }
  postVendorIdentification(e?: any) {
    let payload;
    if (this.schemeType == 'tdf') {
      payload = {
        step: this.resId,
        proposal_step: this.id,
        vendor: e.value.id,
        status: 1
      }
    } else {
      payload = {
        proposal_step: this.id,
        vendor: e.value.id,
        status: 1
      }
    }
    let url;
    if (this.schemeType == 'idex') {
      url = `/idex/vendor-identification/`
    } else if(this.schemeType == 'tdf'){
      url = `/tdf/vendor-identification/`
    }else if(this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII'){
      url = `/make1/vendor-identification/`
    } else {
      url = `/revenue/vendor-identification/`
    }
    const sub = this.api.postAPI(url, payload).subscribe((res: any) => {
      if (res) {
        // this.selectedVendorList = [...this.selectedVendor , res]
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Vendor Identification added successfully'
        });
        this.getVendorIdentification();
      }
    });
    this.subscriptions.add(sub);
  }



  onSelect(event: any) {
    this.selectedVendorList.push(event.value);
    this.selectedVendor = null;
    this.commentForm.reset();
    this.postVendorIdentification(event);
  }

  addVendorFromMaster() {
    
    if (this.selectedMasterVendor.length > 0) {
      console.log("vendor", this.selectedMasterVendor)
    
       
      let payload;
      if (this.schemeType == 'tdf') {
        payload = {
          proposal_step: this.id,
          step:this.resId,
          vendor_id: this.selectedMasterVendor,
          status: 1
        };
      } else {
        payload = {
          step: this.resId,
          vendor_id: this.selectedMasterVendor,
          status: 1
        };
      }

      // Prevent duplicates by checking if already added
      const alreadyAdded = this.venderList?.some(v => this.selectedMasterVendor.includes(v.vendor?.id));
      if (alreadyAdded) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Duplicate',
          detail: 'Vendor already added.'
        });
        this.selectedMasterVendor = [];
        return;
      }
      let url;
       if (this.schemeType == 'idex') {
        url = `/idex/vendor-identification/`
      } else if(this.schemeType == 'tdf'){ 
        url = `/tdf/vendor-identification/`
      }else if(this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII'){
      url = `/make1/vendor-identification/`
    }  else {
        url = `/revenue/vendor-identification/`
      }
     
      const sub = this.api.postAPI(url, payload).subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Vendor added to identification.'
        });
        this.subscriptions.add(sub);
        this.selectedMasterVendor = [];
        this.getVendorIdentification(); // Refresh the table
      });
    }
  }

  openAdd() {
    this.visible = true;
    this.commentForm.reset();
  }

  onSubmit() {
    // if (this.commentForm.valid) {
    let payload;
    let url;
    if (this.schemeType == 'idex') {
      payload = {
        proposal_step: this.id,
        // name: this.systemForm.get('name')?.value,
        company_name: this.systemForm.get('name')?.value,
        description: this.systemForm.get('description')?.value,
        scheme: parseInt(this.payload.scheme)
      }
      url = `/idex/add/vendor/`
    } else if(this.schemeType == 'tdf'){
      payload = {
        step: this.resId,
        step_id: this.resId,
        proposal_step: this.id,
        // name: this.commentForm.get('vendor')?.value,
        company_name: this.commentForm.get('vendor')?.value,
        email: this.commentForm.get('email')?.value,
        contact: this.commentForm.get('contactPerson')?.value,
        phone_number: this.commentForm.get('phone')?.value,
        address: this.commentForm.get('address')?.value,
        tax_number: this.commentForm.get('taxNumber')?.value,
        bank_details: this.commentForm.get('bankDetails')?.value,
        status: 1
      };
      url = `/tdf/vendor-identification/`
    } else {
      payload = {
        proposal_step: this.id,
        company_name: this.commentForm.get('vendor')?.value,
        email: this.commentForm.get('email')?.value,
        contact: this.commentForm.get('contactPerson')?.value,
        phone_number: this.commentForm.get('phone')?.value,
        address: this.commentForm.get('address')?.value,
        tax_number: this.commentForm.get('taxNumber')?.value,
        bank_details: this.commentForm.get('bankDetails')?.value,
        status: 1
      };
      url = `/revenue/add/vendor/`
    }


    if (this.selectedvendor) {
      const sub = this.api.putAPI(url + `${this.selectedvendor.id}/`, payload).subscribe({
        next: (res: any) => {
          // this.venderList = [...this.venderList, res];
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor added successfully'
          });
          this.visible = false;
          this.commentForm.reset();
          this.selectedVendor = null

          this.getVendorIdentification()
        },
        error: (err) => {
          console.error('Error while saving mapping:', err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save mapping. Please try again.'
          });
        }
      });
    } else {
      const sub = this.api.postAPI(url, payload).subscribe({
        next: (res: any) => {
          // this.venderList = [...this.venderList, res];
          // this.masterVendorList = res

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor added successfully'
          });
          this.visible = false;
          this.commentForm?.reset();
          this.systemForm.reset();
          this.getVendorIdentification()
        },
        error: (err) => {
          console.error('Error while saving mapping:', err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save mapping. Please try again.'
          });
        }
      });
      this.subscriptions.add(sub);
    }
    // }
  }
  onEdit(event: any) {
    this.visible = true;
    this.selectedvendor = event.vendor;
    this.commentForm.patchValue({
      vendor: this.selectedvendor.name,
      contactPerson: this.selectedvendor.contact,
      email: this.selectedvendor.email,
      phone: this.selectedvendor.phone_number,
      address: this.selectedvendor.address,
      taxNumber: this.selectedvendor.tax_number,
      bankDetails: this.selectedvendor.bank_details
    });

  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) return;

    const isNumber = /^[0-9]$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
    }
  }

  
   visiblePopup: boolean = false;
  confirmChecked=false;

  showConfirm() {
      if (!this.visiblePopup) {
          this.confirmChecked = false; // Reset checkbox when opening the modal
          this.messageService.add({ key: 'confirm', sticky: true, severity: 'info', summary: 'Are you sure you want to submit this proposal?' });
          this.visiblePopup = true;
      }
  }

    onReject() {
      this.messageService.clear('confirm');
      this.visiblePopup = false;
      this.confirmChecked = false; // Reset checkbox when closing the modal
  }
// submitIRA() {
//   const iraPayload = {
//     proposal_step: this.id, // Using the component's id which seems to be proposal_step
//     // user: this.userID, // From your component
//     // user : parseInt(this.userID),
//     user : sessionStorage.getItem('user_id'),
//     approve_status: 1, // 1 for accept, 2 for reject
//     final_approval: this.confirmChecked ? 1 : 0, // Convert boolean to 1/0
//     remark: "", 
//     unit: sessionStorage.getItem('unit_id'),
    
//     // unit: this.challengeForm.get('coordinatingAgency')?.value || 2 // Using coordinating agency or default
//   };
//   console.log("unit id is", iraPayload.unit);
//   const sub = this.api.postAPI('/transaction/copy/proposal-ira-action/',
//     iraPayload
//   ).subscribe({
//     next: (response: any) => {
//       this.messageService.add({
//         severity: 'success',
//         summary: 'Success',
//         detail: 'IRA action submitted successfully',
//       });
//       // Emit the IRA data if needed by parent component
//       this.IRA.emit(response);
//       console.log('IRA submission response:', response);
//     },
//     error: (err) => {
//       console.error('IRA submission failed:', err);
//       this.messageService.add({
//         severity: 'error',
//         summary: 'Error',
//         detail: 'Failed to submit IRA action',
//       });
//     }
//   });
  
//   this.subscriptions.add(sub);
// }
//   onConfirm() {
//       this.messageService.clear('confirm');
//       this.visiblePopup = false;
//       this.submitIRA();
//       this.routeConfig.emit({isRouteConfig: true, isFinalApproval: this.confirmChecked});
//   }

 
  //  routeconfig() {
  //     console.log('routeconfig');
  //     this.messageService.clear('confirm');
  //     this.visiblePopup = false;
  //     this.confirmChecked = false; // Reset checkbox when closing the modal
  //     this.routeConfig.emit({isRouteConfig: false});
  // }
}